<script setup lang="ts">
import { onMounted, toRefs } from 'vue';
import { RouterView } from 'vue-router';

import Loader from '@/components/ui/Loader.vue';
import { useEventBus } from '@/composables/useEventBus';
import MainLayout from '@/layouts/MainLayout.vue';
import { useCompanyStore } from '@/stores/company';
import { useUserStore } from '@/stores/user';
import SegmentAnalytics, { ANALYTICS_EVENTS } from '@/utils/analytics';
import { initCSRF } from '@/utils/httpClient';
import { setupI18n } from '@/utils/i18n.ts';

const userStore = useUserStore();
const companyStore = useCompanyStore();
const { isAppInitialized } = toRefs(userStore);
const eventBus = useEventBus();

onMounted(async () => {
  await initCSRF();
  const currentUser = await userStore.getCurrentUser();
  await setupI18n();
  isAppInitialized.value = true;

  if (currentUser) {
    await SegmentAnalytics.identifyUser(currentUser);
    await SegmentAnalytics.identifyGroup();

    if (currentUser.superAdmin) {
      await companyStore.getCompanies();
    }
  }

  SegmentAnalytics.trackEvent(ANALYTICS_EVENTS.appOpened);

  eventBus.$on('resetApplicationStates', () => {
    window.location.href = '/';
  });
});
</script>

<template>
  <MainLayout
    v-if="!isAppInitialized"
    centered
  >
    <Loader />
  </MainLayout>

  <template v-else>
    <RouterView />
  </template>
</template>
